<script setup lang="ts">
defineProps<{
  fill?: string;
}>();
</script>

<template>
  <svg
    width="45"
    height="143"
    viewBox="0 0 45 143"
    fill="#EAC93A"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.6824 0.918484C32.0851 -0.0106556 30.8476 -0.279661 29.9185 0.317643C28.9893 0.914948 28.7203 2.15238 29.3176 3.08152L32.6824 0.918484ZM17.8253 61L19.0734 62.5628L17.8253 61ZM16.5866 142.57C17.4538 143.254 18.7114 143.106 19.3955 142.239L30.5439 128.107C31.228 127.239 31.0796 125.982 30.2124 125.298C29.3452 124.614 28.0876 124.762 27.4035 125.629L17.4938 138.191L4.932 128.281C4.06479 127.597 2.80719 127.746 2.12307 128.613C1.43895 129.48 1.58737 130.738 2.45458 131.422L16.5866 142.57ZM29.3176 3.08152C38.3714 17.1651 41.7684 25.4561 40.0508 32.895C39.1906 36.6205 36.9958 40.3514 33.1222 44.6415C29.2415 48.9394 23.7885 53.6778 16.5772 59.4372L19.0734 62.5628C26.3113 56.7821 31.9797 51.8755 36.0911 47.3221C40.2095 42.7609 42.8771 38.4343 43.9483 33.7949C46.0935 24.5038 41.6286 14.8349 32.6824 0.918484L29.3176 3.08152ZM16.5772 59.4372C8.5087 65.8813 3.90445 71.6485 1.84457 77.4812C-0.233113 83.3643 0.383366 89.0134 2.10857 94.9503C3.79106 100.74 6.70836 107.306 9.34442 114.619C12.0282 122.065 14.5953 130.696 15.8391 141.234L19.8115 140.766C18.5205 129.827 15.8552 120.886 13.1074 113.263C10.3119 105.507 7.59852 99.5081 5.94968 93.8341C4.34355 88.307 3.92806 83.5935 5.61627 78.8132C7.32229 73.9825 11.2818 68.7857 19.0734 62.5628L16.5772 59.4372Z"
      :fill="fill"
    />
  </svg>
</template>

<style scoped>
svg {
  path {
    fill: var(--graphics, v-bind(fill));
  }
}
</style>
